import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import {tap} from 'rxjs/operators';
import { Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Utils} from "../Utils/utils"
import { BroadcastService } from "../Helpers/broadcast.service";
import { CrudService } from "../Services/crud.service"

enum Event {
    LogIN  
}

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {    

    timeout;    
    public utils: Utils;

    constructor(private router: Router, private modalService: NgbModal, private broadcastService: BroadcastService<Event>, private crudService: CrudService) { 
        this.utils = new Utils(modalService, broadcastService, crudService);
    }
   
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {        
        // Request if applicate reuire before passing to server
        let cloneReq = request;
        if (localStorage.getItem("access_token")) {
            cloneReq = request.clone({ headers: request.headers.set("Authorization", localStorage.getItem("access_token") ) });     
        } 

        return next.handle(cloneReq).pipe( tap(() => {},
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 401) {
                        return;
                    }
                    // For unauthorize 401 redirect to login page
                    this.router.navigate(['/']);
                }
        }));
    }
   
}